import BasicArray from './BasicArray';
import Classroom from "./Classroom";

export default class ClassroomArray extends BasicArray {
    get myItemClass() { return Classroom; }

    constructor(items = []) {
        super(items);
    }
}
